// ==============================|| DEFAULT THEME - TYPOGRAPHY ||============================== //

export default function Typography(fontFamily) {
  return {
    htmlFontSize: 16,
    fontFamily,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 600,
    h1: {
      fontWeight: 600,
      fontSize: '2.75rem',
      lineHeight: 1.21
    },
    h2: {
      fontWeight: 600,
      fontSize: '2.2rem',
      lineHeight: 1.27
    },
    h3: {
      fontWeight: 600,
      fontSize: '1.75rem',
      lineHeight: 1.33
    },
    h4: {
      fontWeight: 600,
      fontSize: '1.5rem',
      lineHeight: 1.4
    },
    h5: {
      fontWeight: 600,
      fontSize: '1.3rem',
      lineHeight: 1.5
    },
    h6: {
      fontWeight: 400,
      fontSize: '1.2rem',
      lineHeight: 1.57
    },
    caption: {
      fontWeight: 400,
      fontSize: '1.05rem',
      lineHeight: 1.66
    },
    // body1/h6/subtitle1 sit at 1rem (16px) deliberately - the general
    // mobile-readability minimum, and it also stops iOS Safari's
    // auto-zoom-on-focus on inputs smaller than 16px (this app is full of
    // OutlinedInput fields, so that's a real, not just cosmetic, win).
    // User-reported bug (2026-08-21): every text size here was static
    // across all breakpoints and several variants sat at 0.75rem (12px),
    // unreadably small on mobile - bumped globally since this is the one
    // source of truth for the whole MUI theme (themes/index.jsx), not a
    // per-page fix.
    body1: {
      fontSize: '1.2rem',
      lineHeight: 1.57
    },
    body2: {
      fontSize: '1.05rem',
      lineHeight: 1.66
    },
    subtitle1: {
      fontSize: '1.2rem',
      fontWeight: 600,
      lineHeight: 1.57
    },
    subtitle2: {
      fontSize: '1.05rem',
      fontWeight: 500,
      lineHeight: 1.66
    },
    overline: {
      lineHeight: 1.66
    },
    button: {
      textTransform: 'capitalize'
    }
  };
}
